import authLogger from './auth-logger'
const SESSION_STORAGE_TOKEN_KEY = 'rg_origin'
const ALLOWED_ORIGIN_CONTEXTS = [
  'encompass-sdk',
  'encompass-api',
  'encompass-tpo',
  'helpdesk',
]

export const contextOriginService = {
  /**
   * Get token
   * @returns {string|null} The token from sessionStorage or null if not found
   */
  getToken: () => {
    const currentToken = sessionStorage.getItem(SESSION_STORAGE_TOKEN_KEY)
    if (contextOriginService.validateOrigin(currentToken)) {
      return currentToken
    }
    contextOriginService.removeToken()
    return null
  },

  /**
   * Set token in storage
   * @param {string} token
   */
  setToken: (token) => {
    if (contextOriginService.validateOrigin(token)) {
      authLogger.debug(`Setting rg_origin to ${token}`)
      sessionStorage.setItem(SESSION_STORAGE_TOKEN_KEY, token)
    } else {
      authLogger.debug(`Invalid rg_origin: ${token}`)
      contextOriginService.removeToken()
    }
  },

  /**
   * Remove token from storage
   * @returns {void}
   * Removes the token from sessionStorage
   */
  removeToken: () => {
    sessionStorage.removeItem(SESSION_STORAGE_TOKEN_KEY)
  },

  /**
   * Validates the reggora origin
   * @param {*} expectedContext
   * @returns {boolean}
   */
  validateOrigin: (expectedContext) => {
    if (!expectedContext) {
      return false
    }

    return ALLOWED_ORIGIN_CONTEXTS.includes(expectedContext)
  },
}
